var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "block",
      transform: "scale(-1,1)"
    }
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#002010"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1177 22.5H12.6177V25.5H14.1177V22.5ZM35.5693 25.0607C36.1551 24.4749 36.1551 23.5251 35.5693 22.9393L26.0233 13.3934C25.4375 12.8076 24.4878 12.8076 23.902 13.3934C23.3162 13.9792 23.3162 14.9289 23.902 15.5147L32.3873 24L23.902 32.4853C23.3162 33.0711 23.3162 34.0208 23.902 34.6066C24.4878 35.1924 25.4375 35.1924 26.0233 34.6066L35.5693 25.0607ZM14.1177 25.5L34.5086 25.5V22.5L14.1177 22.5V25.5Z",
    fill: "#C7F700"
  })));
};
export default SvgArrowLeft;